"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keysArePopulatedString = exports.keysArePopulated = exports.validAttributePresent = exports.validAttributeBitmapValue = exports.validAttributeEnumValue = exports.validAttributeBooleanValue = exports.validAttributeNumberValue = exports.isKnownValue = exports.bothNullish = exports.isNullish = exports.isValidDate = exports.isBoolean = exports.isNonNullObject = exports.isNonNaNNumber = void 0;
const validationTypes_1 = require("./validationTypes");
const debug = false;
/** tests that is number, ie not NaN, undefined or null */
const isNonNaNNumber = (x) => !!(typeof x === 'number' && !isNaN(x));
exports.isNonNaNNumber = isNonNaNNumber;
/** tests that is object, ie not NaN, undefined or null */
const isNonNullObject = (x) => !!(!!x && typeof x === 'object');
exports.isNonNullObject = isNonNullObject;
/** test that x is true or false, ie avoids !!true */
const isBoolean = (x) => x === true || x === false;
exports.isBoolean = isBoolean;
const isValidDate = (x) => x instanceof Date && !isNaN(x.getTime());
exports.isValidDate = isValidDate;
const isNullish = (a) => a === null || a === undefined;
exports.isNullish = isNullish;
const bothNullish = (a, b) => (0, exports.isNullish)(a) && (0, exports.isNullish)(b);
exports.bothNullish = bothNullish;
/** tests that x is set including null,  set includeNulls to false if nulls are to be tested for truthiness */
const isKnownValue = (x, includeNulls) => (includeNulls && x === null) || (0, exports.isBoolean)(x) || !!x || (0, exports.isNonNaNNumber)(x) || x === '';
exports.isKnownValue = isKnownValue;
const validAttributeNumberValue = (value, range) => {
    const isNumber = (0, exports.isNonNaNNumber)(value);
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.NOT_NUMBER,
    };
    switch (isNumber) {
        case true:
            {
                res.error = validationTypes_1.AttributeValidationError.OUTSIDE_RANGE;
                const lowPred = !(0, exports.isNonNaNNumber)(range.min) || range.min <= value;
                const hiPred = !(0, exports.isNonNaNNumber)(range.max) || range.max >= value;
                const inRange = lowPred && hiPred;
                switch (inRange) {
                    case true:
                        {
                            res.error = null;
                            res.isValid = true;
                        }
                        break;
                    default: {
                        debug && console.log(`${value} ${res.error}`);
                    }
                }
            }
            break;
        default: {
            debug && console.log(`${value} ${res.error}`);
        }
    }
    return res;
};
exports.validAttributeNumberValue = validAttributeNumberValue;
const validAttributeBooleanValue = (value) => {
    const isBoolean = typeof value === 'boolean';
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.NOT_BOOLEAN,
    };
    switch (isBoolean) {
        case true:
            {
                res.error = null;
            }
            break;
        default: {
            debug && console.log(`${value} ${res.error}`);
        }
    }
    return res;
};
exports.validAttributeBooleanValue = validAttributeBooleanValue;
const validAttributeEnumValue = (value, enumeration) => {
    const isPossibleKey = ['string', 'number'].includes(typeof value);
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.NOT_ENUM_VALUE,
    };
    if (isPossibleKey) {
        const isEnumKey = Object.values(enumeration).includes(value);
        if (isEnumKey) {
            ;
            (res.error = null), (res.isValid = true);
        }
        else {
            console.log(`${value} ${res.error}`);
        }
    }
    return res;
};
exports.validAttributeEnumValue = validAttributeEnumValue;
const validAttributeBitmapValue = (value, bitmap) => {
    const isPossibleKey = typeof value === 'number';
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.NOT_BITMAP_VALUE,
    };
    if (isPossibleKey) {
        const isBitmapKey = Object.values(bitmap).includes(value);
        if (isBitmapKey) {
            res.error = null;
            res.isValid = true;
        }
        else {
            console.log(`${value} ${res.error}`);
        }
    }
    return res;
};
exports.validAttributeBitmapValue = validAttributeBitmapValue;
const validAttributePresent = (value) => {
    const isPresent = true;
    const res = {
        isValid: false,
        error: validationTypes_1.AttributeValidationError.NOT_ENUM_VALUE,
    };
    if (isPresent) {
        ;
        (res.error = null), (res.isValid = true);
    }
    return res;
};
exports.validAttributePresent = validAttributePresent;
const keysArePopulated = (value) => {
    if (typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, (0, exports.isKnownValue)(v, false)]));
    }
    else {
        return {};
    }
};
exports.keysArePopulated = keysArePopulated;
/** for dev, show which keys are null or undefined, */
const keysArePopulatedString = (value) => {
    const x = (0, exports.keysArePopulated)(value);
    const sep = ', ';
    return Object.entries(x).reduce((a, [k, b], i) => {
        a += `${i === 0 ? '' : sep}${k}: ${b}`;
        return a;
    }, '');
};
exports.keysArePopulatedString = keysArePopulatedString;
